<div class="pagination-dark-wrapper dark-mode">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-6">

            <div class="pagination-info mt-3">
                Show Per Page
                <mat-form-field class="dense" style="width: 80px; margin-left: 10px; margin-right: 10px;" appearance="outline">
                    <mat-select [(ngModel)]="perPage" (ngModelChange)="onPerPageChange($event)">
                        <mat-option [value]="10">10</mat-option>
                        <mat-option [value]="25">25</mat-option>
                        <mat-option [value]="50">50</mat-option>
                        <mat-option [value]="100">100</mat-option>
                    </mat-select>
                </mat-form-field>
                {{ (page * perPage) + 1  }} -
                <span *ngIf="(page * perPage) + perPage <= count; else elsePagination">{{ (page * perPage) + perPage }}</span>
                <ng-template #elsePagination>
                    <span >{{ (count ) }}</span>
                </ng-template>

                of {{ count }} entries
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
            <ul class="pagination mt-3">
                <li (click)="toFirst()" class="page-item">
                    <a class="page-link">First</a>
                </li>
                <li (click)="toPrev()" class="page-item">
                    <a class="page-link">&lang;</a>
                </li>
                <ng-container *ngFor="let pageNum of getPages()">
                    <li (click)="onPage(pageNum)" *ngIf="pageNum === (page + 1)" class="page-item active">
                        <a class="page-link">{{ pageNum }}</a>
                    </li>
                    <li (click)="onPage(pageNum)" *ngIf="!(pageNum === (page + 1))" class="page-item">
                        <a class="page-link">{{ pageNum }}</a>
                    </li>
                </ng-container>
                <li (click)="toNext()" class="page-item">
                    <a class="page-link">
                        &rang;
                    </a>
                </li>
                <li (click)="toLast()" class="page-item">
                    <a class="page-link">Last</a>
                </li>
            </ul>

        </div>
    </div>


</div>

